import React, { useState, useRef, useEffect } from 'react'
import { Image, View } from 'react-native'
import GameInfo from '../GameInfo/GameInfo'
import { commonStyle } from '../../assets/TextStyles/TextStyles'
import { initialGameInfo } from '../../App'
import Deck from '../Deck/Deck'
import CardSlots, { getCardSlotData, getNumCardSlots } from '../CardSlots/CardSlots'

import gameBoard from './board_2.png'
import Feedback from '../Feedback/Feedback'

import Dialog from '../Dialog/Dialog'
import CardInfo from '../CardInfo/CardInfo'
import { cardInfos } from '../../assets/CardInfos/CardInfos'
import Pilots from '../Pilots/Pilots'
import { instructions } from '../../assets/Instructions/Instructions'

const GameBoard = () => {
  const [gameInfo, setGameInfo] = useState(initialGameInfo)
  const [color, setColor] = useState('')
  const [cardsDropped, setCardsDropped] = useState(0)
  const [cardsRemoved, setCardsRemoved] = useState(0)
  const [card1ID, setCard1ID] = useState('')
  const [card2ID, setCard2ID] = useState('')
  const [card3ID, setCard3ID] = useState('')
  const [showPilots, setShowPilots] = useState(false)
  const [showCardInfo, setShowCardInfo] = useState(false)
  const [showExample, setShowExample] = useState(false)
  const [cardInfo, setCardInfo] = useState('')
  const [example, setExample] = useState('')
  const [zIndexCardInfo, setZIndexCardInfo] = useState(1)

  const usedSlots = useRef(Array(getNumCardSlots()).fill(false)).current
  const cardInfoID = useRef('')

  const GAMESTATE = {
    instructions1: '1',
    instructions2: '2',
    instructions3: '3',
    instructions4: '4',
    instructions5: '5',
    cardinfo: '6',
    instructions6: '7',
    game: '8',
    feedback: '9'
  }

  const [gameState, setGameState] = useState(GAMESTATE.instructions1)

  const handleBeginDrag = (color) => {
    setColor(color)
    setZIndexCardInfo(0)
  }

  useEffect(() => {
    if (gameState === GAMESTATE.instructions3) {
      setGameState(GAMESTATE.instructions4)
    }
  }, [cardsDropped])

  useEffect(() => {
    if (gameState === GAMESTATE.instructions4) {
      setGameState(GAMESTATE.instructions5)
    }
  }, [cardsRemoved])

  const startGame = () => {
    for (let index = 0; index < usedSlots.length; index++) {
      usedSlots[index] = false
    }
    setCard1ID('')
    setCard2ID('')
    setCard3ID('')
    setGameInfo(initialGameInfo)
    setGameState(GAMESTATE.game)
    setCardsDropped(0)
    setCardsRemoved(0)
  }

  const handleEndDrag = (isCardDragged, slotIndex, co2Reductions, cashSavings) => {
    setZIndexCardInfo(1)

    if (slotIndex !== -1) {
      setCardsDropped((prevCardsDropped) => prevCardsDropped + 1)
    } else if (isCardDragged) {
      setCardsRemoved((prevCardsRemoved) => prevCardsRemoved + 1)
    }

    if (slotIndex !== -1) {
      usedSlots[slotIndex] = true
      const slot = getCardSlotData(slotIndex)
      const propCo2 = 'co2' + slot.p
      const propCash = 'cash' + slot.p

      setGameInfo((prevGameInfo) => {
        const reductions = Math.min(prevGameInfo[propCo2], co2Reductions)
        const savings = Math.min(prevGameInfo[propCash], cashSavings)

        return {
          ...prevGameInfo,
          [propCo2]: prevGameInfo[propCo2] - reductions,
          [propCash]: prevGameInfo[propCash] - savings,
          totalReductions: prevGameInfo.totalReductions + reductions,
          totalSavings: prevGameInfo.totalSavings + savings
        }
      })
    }
    setColor('')
  }

  const handleCardInfoOpen = (ID) => {
    cardInfoID.current = ID
    if (gameState === GAMESTATE.instructions5) {
      setGameState(GAMESTATE.cardinfo)
    }
    setCardInfo(cardInfos[ID])
    setShowCardInfo(true)
  }

  const handleOpenExample = () => {
    setExample(cardInfos[cardInfoID.current + '_esim'])
    setShowExample(true)
  }

  const handleCardInfoClose = () => {
    if (gameState === GAMESTATE.cardinfo) {
      setGameState(GAMESTATE.instructions6)
    }
    setShowCardInfo(false)
  }

  const handleCardBeginDeal = () => {
    setGameInfo((prevGameInfo) => {
      return {
        ...prevGameInfo,
        cardsLeft: prevGameInfo.cardsLeft - 1
      }
    })
  }

  const handleCardDealt = (index, ID) => {
    if (index === 0) {
      setCard1ID(ID)
    } else if (index === 1) {
      setCard2ID(ID)
    } else if (index === 2) {
      setCard3ID(ID)
    }
  }

  const handleGameFinished = () => {
    setGameState(GAMESTATE.feedback)
  }

  const handleDisableCardInfo = (index) => {
    if (index === 0) {
      setCard1ID('')
    } else if (index === 1) {
      setCard2ID('')
    } else if (index === 2) {
      setCard3ID('')
    }
  }

  const gameStatesToShowDeck = [GAMESTATE.game, GAMESTATE.instructions3, GAMESTATE.instructions4, GAMESTATE.instructions5]

  return (
    <View style={[styles.gameBoard, commonStyle.corner, commonStyle.dropShadow]}>
        <Image source={gameBoard} style={styles.gameBoard} />
        <GameInfo {...gameInfo} />
        <CardSlots color={color} />
        <CardInfo style={{ zIndex: zIndexCardInfo }} onOpen={handleCardInfoOpen} card1ID={card1ID} card2ID={card2ID} card3ID={card3ID} />
        { gameStatesToShowDeck.includes(gameState) &&
          <Deck gameInfo={gameInfo} usedSlots={usedSlots} onDisableInfo={handleDisableCardInfo} onGameFinished={handleGameFinished} onBeginDrag={handleBeginDrag} onEndDrag={handleEndDrag} onCardBeginDeal={handleCardBeginDeal} onCardDealt={handleCardDealt} />
        }
        <Dialog style={{ height: 635, backgroundColor: '#dde7f5' }} show={gameState === GAMESTATE.feedback} openInfo={handleCardInfoOpen} showHeader={true} content={<Feedback gameInfo={gameInfo} />} footer={[
          { title: 'Pelaa uudestaan', callback: startGame }
        ]}/>
        <Dialog style={{ backgroundColor: '#dde7f5' }} show={gameState === GAMESTATE.instructions1} showHeader={true} content={instructions.instructions1} footer={[
          { title: 'Katso ohjeet', callback: () => setGameState(GAMESTATE.instructions2) },
          { title: 'Aloita peli', callback: startGame }
        ]}/>
        <Dialog show={gameState === GAMESTATE.instructions2} content={instructions.instructions2} footer={[
          { title: 'Jatka', callback: () => setGameState(GAMESTATE.instructions3) }
        ]}/>
        <Dialog show={gameState === GAMESTATE.instructions3} content={instructions.instructions3} footer={[]}/>
        <Dialog show={gameState === GAMESTATE.instructions4} content={instructions.instructions4} footer={[]}/>
        <Dialog show={gameState === GAMESTATE.instructions5} content={instructions.instructions5} footer={[]}/>
        <Dialog show={gameState === GAMESTATE.instructions6} content={instructions.instructions6} footer={[
          { title: 'Aloita peli', callback: startGame }
        ]}/>
        <Dialog style={{ height: 635 }} show={showPilots} key={'pilots'} content={<Pilots openExample={handleOpenExample} openInfo={handleCardInfoOpen} />} footer={[
          {},
          { title: 'Sulje', callback: () => setShowPilots(false) }
        ]}/>
        <Dialog style={{ height: 635 }} show={showCardInfo} key={'cardinfo'} content={cardInfo} footer={[
          { },
          { title: 'Sulje', callback: handleCardInfoClose }
        ]}/>
        <Dialog style={{ height: 635 }} show={showExample} key={'example'} content={example} footer={[
          {},
          { title: 'Sulje', callback: () => setShowExample(false) }
        ]}/>
    </View>
  )
}

const styles = {
  gameBoard: {
    position: 'absolute',
    width: 1200,
    height: 675,
    draggable: 'false',
    userSelect: 'none'
  }
}

export default GameBoard
